import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Link} from "react-router-dom"
import './return-list.css'
import Slider from "react-slick";
import {userList} from '../../redux/chatuser.redux.js'
import { withRouter } from 'react-router-dom'
import {authenticationFn} from '../../redux/chatuser.redux.js'

import {getGiftSuccessCallBack} from  '../../redux/chatuser.redux.js'
@withRouter
@connect(
  state=>state.chatuser,
  {userList,authenticationFn,getGiftSuccessCallBack}
)

class ReturnListPC extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            GetPacks:'',
            getCates:'',
            zoneNum:0,
            navNum:0,
            showSelectWelfare:false,
            visible:false,
            showGetSuccess:false,
            iTop:'',		     
            giftData:'',
            key:1,
            inum:0,
            packId:'',
            showWrongAlert:false
        }
        this.game_id = this.props.match.params.id;
        this.handleLogin = this.handleLogin.bind(this)
        this.myAccountData=''
    }
    componentDidMount(){
		document.title = '心享俱乐部—光明勇士回归特权'
  		if(this.props.inum==='1'){
  			this.handleGetCates('1')
  		}
  		if(this.props.inum==='2'){
  			this.handleGetCates('4')
  		}

    }
    componentWillReceiveProps(nextProps){
		
		if(this.props.getGiftSuccessData!==nextProps.getGiftSuccessData){
			if(nextProps.getGiftSuccessData==='1'){
				
		 		this.state.getCates[this.state.navNum]&&this.handleGetPacks(this.state.getCates[this.state.navNum].id)
		 		this.setState({
		 			myCateNum:0
		 		})
		 		
		 		//var oHref = window.location.href 
		 		//window.location.href = oHref
		 	}
		}
	
  		 if (this.props.accountData.account!== nextProps.accountData.account||nextProps.ikey){
  		 	
  		 	this.myAccountData = nextProps.accountData
  		 	
			if(nextProps.accountData.grade&&this.props.inum==='1'){
				
				const oGrade = nextProps.accountData.grade
				
				var num =''
				if(oGrade>=8){
				num = 2
				}
				if(oGrade>4&&oGrade<=7){
				num = 1
				}
				if(oGrade<=4){
				num = 0
				}
				this.setState({
					navNum:num					
				})
				if(nextProps.ikey){
					this.handleGetCates('1')
					return
				}

		  		this.state.getCates[num]&&this.handleGetPacks(this.state.getCates[num].id,nextProps.accountData)
		  				  		
	  		}
	  		if(!nextProps.accountData.grade){
	  			this.state.getCates[0]&&this.handleGetPacks(this.state.getCates[0].id,nextProps.accountData)
	  			this.setState({
					navNum:0
				})
	  		}
	  		if(this.props.inum==='2'){
	  			
				
	  			if(parseFloat(nextProps.iMoney)||parseFloat(nextProps.iMoney)==0){
	  			
	  			}else{
	  				this.state.getCates[0]&&this.handleGetPacks(this.state.getCates[0].id)
	  			}
	  		}
	  		
  	
  		 }

  	}
    handleGetCates(num){
  		
        axios.get('/fapi/recom/getCates?gameid='+this.game_id+'&type='+num)
          .then(res=>{
              if(res.data.return_code===0){
                  this.setState({
                      getCates:res.data.data
                  })
                  res.data.data.length&&this.handleGetPacks(res.data.data[this.state.navNum].id)
              }
          })

    }
    handleGetPacks(_id,accountData){
        var acData = ''
        if(this.myAccountData.t_account){  			
            acData = this.myAccountData.t_account

        }
        axios.get('/fapi/recom/getPacks?gameid='+this.game_id+'&cateid='+_id+'&account='+acData)
            .then(res=>{
                if(res.data.return_code===0){
					this.setState({
						GetPacks:res.data.data
					})
					this.props.getGiftSuccessCallBack('0')
  				}                         
            })
    } 
    getGiftBtnFn(){
		
        if(this.props.userlist.code===-1){
            var str = '立即领取'
            var icls = 'btn active'
            var callBack = this.handleLogin
            
            if(this.props.inum==2&&this.state.navNum===0){
                str = '1元购买'
            }
            if(this.props.authentication==1||this.props.authentication==''){
              
              return <button className="btn active" onClick={()=>this.handleLogin()}>{str}</button>
            }
            if(this.props.authentication==3){
              
              if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 1){
                  
                    str = '立即领取'
                    
                    if(this.props.inum==2&&this.state.navNum===0){
                        
                     str = '1元购买'
                    }
                }
                if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 0){  				
                     str = '待解锁'
                     icls = 'btn unactive'
                     callBack = function () { }
                }
                if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 2){  				
                     str = '已领取'
                      icls = 'btn unactive'
                      callBack = function () { }
                }
                return <button className={icls} onClick={()=>callBack()}>{str}</button>
            }
            if(this.props.authentication==2){
                return <button className="btn unactive" >待解锁</button>
            }
        }else{
            var str = ''
            var icls = 'btn active'
            var callBack = this.showAlert
            if(this.props.authentication==3){
            
                if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 1){
                  
                    str = '立即领取'
                    
                    if(this.props.inum==2&&this.state.navNum===0){
                        
                     str = '1元购买'
                    }
                    if(this.state.GetPacks[0].alert){
                        callBack=this.showWrongAlert
                    }
                }
                if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 0){  				
                     str = '待解锁'
                     icls = 'btn unactive'
                     callBack = function () { }
                }
                if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 2){  				
                     str = '已领取'
                      icls = 'btn unactive'
                     callBack = function () { }
                }
                return <button className={icls} onClick={(e)=>callBack(e)}>{str}</button>
            }
            if(this.props.authentication==2){
                
                return <button className="btn unactive" >待解锁</button>
            }
        }
        
    }
    handleServe(e){
        var acData = ''
        var iIndex = e.target.options.selectedIndex
        
        if(this.myAccountData.t_account){  			
                acData = this.myAccountData.t_account

        }
        axios.get('/fapi/recom/getPacks?gameid='+this.game_id+'&cateid='+this.state.myCateId+'&account='+acData)
            .then(res=>{
                
                if(res.data.return_code===0){
                    if(this.state.ifRoleNum==98){
                        this.setState({
                            GetPacks:[this.state.roleArr[iIndex]]
                        })
                    }else if(this.state.ifRoleNum===99){
                        this.setState({
                        
                            GetPacks:[this.state.roleArr[iIndex]]
                        })
                    }
                }
            })
    }
    handleNav(i,_id){
		this.setState({
			navNum:i
		})
		this.handleGetPacks(_id)
  	}
    handleLogin(){		
		const pathname = this.props.location.pathname
		axios.get('/fapi/getLoginURL?redirect_url='+encodeURIComponent(encodeURIComponent(window.location.href)))
	      .then(res=>{
	       	if(res.data.return_code==0){
	       		window.location.href = res.data.redirect_url
	       	}		     
		 })
	}
    render() {
        return (
            <div>
                <div className="sdtq-content">
                    <div className="sdtq-nav">
                        <ul>
                            {
                                this.state.getCates && this.state.getCates.map((item, i) => {
                                    return (
                                    <li key={i} className={i === this.state.navNum? 'active' : ''} onClick={() => this.handleNav(i, item.id)}>
                                        {item.name}
                                        {this.props.inum === '2' ? '' : <i></i>}
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                    <div className="gifts-list-box">
                        <div className="gifts-list">
                            <ul>
                                {
                                    this.state.GetPacks && this.state.GetPacks[0].images.map((item, i) => (
                                        <li key={i}>
                                            <div className="">
                                                <img src={item.imgurl} />
                                            </div>
                                            <p>{item.title}</p>
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                        {this.getGiftBtnFn()}
                    </div>
                </div>
            </div>
        )
    }
}

export default ReturnListPC;


// WEBPACK FOOTER //
// ./src/component/return-list-pc/return-list.js